module.exports = __webpack_public_path__ + "img/warbound.a1e07bd3.svg";